// datoteka: src/hooks/useMediaQuery.js
import { useState, useEffect } from 'react';

function useMediaQuery(query) {
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const documentChangeHandler = () => setMatches(mediaQueryList.matches);

        // Dodamo poslušalca za spremembe velikosti zaslona
        mediaQueryList.addEventListener('change', documentChangeHandler);

        // Počistimo poslušalca, ko se komponenta uniči
        return () => {
            mediaQueryList.removeEventListener('change', documentChangeHandler);
        };
    }, [query]);

    return matches;
}

export default useMediaQuery;